import React, { createContext, useContext, useMemo } from 'react';
export const NavigationHelperContext = createContext({
    getUrlForRoute: (routeId) => {
        return routeId;
    },
    showDrawer: () => { },
    closeDrawer: () => { },
    getMenuItemsByGroupId: () => [],
    getSearchDataByParentRouteId: (routeId) => [{ routeId }],
    setPageDescription: () => { },
});
export const useNavigationHelpers = () => {
    const context = useContext(NavigationHelperContext);
    if (context === null) {
        throw new Error('useNavigationHelperContext must be used within a NavigationProvider');
    }
    return context;
};
export const NavigationHelperProvider = ({ children, getUrlForRoute, showDrawer, closeDrawer, getMenuItemsByGroupId, getSearchDataByParentRouteId, setPageDescription, }) => {
    const value = useMemo(() => {
        return {
            getUrlForRoute,
            showDrawer,
            closeDrawer,
            getMenuItemsByGroupId,
            getSearchDataByParentRouteId,
            setPageDescription,
        };
    }, [
        getUrlForRoute,
        showDrawer,
        closeDrawer,
        getMenuItemsByGroupId,
        getSearchDataByParentRouteId,
        setPageDescription,
    ]);
    return (React.createElement(NavigationHelperContext.Provider, { value: value }, children));
};
